import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataLastUpdated } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import Moment from 'moment/moment';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function LastUpdated(props: IElementDataLastUpdated) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { elementType = '', lastDisplayGenerationTime = '', lastFileUpdatedTime = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'last_updated';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (
        !fieldMetadataDisplay ||
        !(
            (lastDisplayGenerationTime && elementType != 'other external content') ||
            (lastFileUpdatedTime && elementType == 'other external content')
        )
    )
        return null;

    let label: string = fieldKey;
    if (elementType == 'external report') label = 'last_taken';
    if (elementType == 'other external content') label = 'last_modified';

    const value = elementType == 'other external content' ? lastFileUpdatedTime : lastDisplayGenerationTime;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>{t(`element_data_label.${label}`)}</ElementDataRowLabel>
            <ElementDataRowValue>{Moment(value).format('MMM DD, yyyy H:mm')}</ElementDataRowValue>
        </ElementDataRow>
    );
}
